/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAccounts = {
  init: function($section){

    $('.js-recover-password').on('click', function(){
      $('#login').hide();
      $('#recover-password').show();
    });

    $('.cancel-recover-password').on('click', function(){
      $('#recover-password').hide();
      $('#login').show();
    })

    var urlParams = new URLSearchParams(window.location.search);
    var recover = urlParams.has('recover');
    var emailParam = urlParams.has('email')

    if(window.location.href.indexOf('#recover') > -1) {
      $('#login').hide();
      $('#recover-password').show();
    } 

    if (recover && emailParam && urlParams.get('recover') == 'show' ) {
      console.log('yes recover, emailparam, url params')
      $('#login').hide();
      $('#recover-password').show();

      const emailField = document.getElementById('recover-email')
      emailField.value = urlParams.get('email')
    }

  },

  unload: function($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
}

/******/ })()
;